import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../../common/breadcrumbs";
// import Loader from "../../../../common/loader";
import CustomCkeditor from "../../../../common/customeditor";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
    validateYouTubeUrl,
} from "../../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import { DetailsEducationalVideo, EditEducationalVideo } from "../../../../services/usermgmt.services";

const EducationalVideoEdit = () => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const [showdefault, setShowDefault] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const [saveType, setSaveType] = useState("");
    const { t } = useTranslation()
    const [showVideoData, setShowVideoData] = useState({});
    const [previewimage, setPreviewImage] = useState("");
    const [categories, setCategories] = useState([]);
    const { center_id } = location.state;

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        {
        title: t("Center Management"),
        url: "/admin/center-management/center/list/1",
        },
        {
        title: t("Videos"),
        url: `/admin/center-management/center/educational-video/${center_id}/list/1`,
        },
        { title: t("admin.faq.link_edit"), url: "" },
    ];

    useEffect(() => {
        DetailsEducationalVideo(params.id)
            .then((data) => {
                setShowDefault(data && data?.data ? data.data : []);
                setShowVideoData(data?.data?.video);
                setPreviewImage(data.data.thumbnail_image);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);

    // useEffect(() => {
    //     videoServices
    //         .AllCategoryList()
    //         .then((res) => {
    //             setCategories(res.data);
    //         })
    //         .catch((error) => {
    //             console.log("error", error);
    //         });
    // }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (<Formik
                enableReinitialize
                initialValues={{
                    title: showdefault && showdefault.title ? showdefault.title : "",
                    description: showdefault && showdefault.description ? showdefault.description : "",
                    // category: showdefault && showdefault.category ? showdefault.category : "",
                    video_length: showdefault && showdefault.video_length ? showdefault.video_length : "",
                    video_type: showdefault && showdefault.video_type ? showdefault.video_type : "",
                    video: showdefault && showdefault.video ? showdefault.video : "",
                    video_link: showdefault && showdefault.video_link ? showdefault.video_link : "",
                    thumbnail_image: showdefault && showdefault.thumbnail_image ? showdefault.thumbnail_image : "",
                }}
                validate={(values) => {
                    const error = {};
                    const MAX_VIDEO_SIZE_MB = 10;
                    const MAX_IMAGE_SIZE_MB = 1.5; 
                    const allowedTypes = ["video/mp4", "video/webm", "video/ogg", "video/quicktime"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    // if (!values.category) {
                    //     error.category = "Category is required";
                    // }

                    if (values.thumbnail_image) {
                        const isFile = values.thumbnail_image instanceof File || values.thumbnail_image instanceof Blob;
                        if (isFile) {
                            const fileSizeMB = values.thumbnail_image.size / (1024 * 1024);
                            if (fileSizeMB > MAX_IMAGE_SIZE_MB) {
                                error.thumbnail_image = `Thumbnail image size should not exceed ${MAX_IMAGE_SIZE_MB}MB.`;
                            }
                        }
                    }

                    // if (!values.video) {
                    //     error.video = "Please upload a video.";
                    // } else {
                    //     const isFile = values.video instanceof File || values.video instanceof Blob;

                    //     if (isFile) {
                    //         if (!allowedTypes.includes(values.video.type)) {
                    //             error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                    //         }

                    //         const fileSizeMB = values.video.size / (1024 * 1024);
                    //         if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                    //             error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                    //         }
                    //     }
                    // }
                    // Require at least one: video or video_link
                    // if (!values.video_length && !values.video_length.trim()) {
                    //     error.video_length = "Please select a video length.";
                    // }
                    if (!values.video_length && !values.video_length.trim()) {
                        error.video_length = "Please select a video length.";
                    } else if (values.video_length === "short" && values.video_type === "link") {
                        // Validate for YouTube Shorts
                        const shortError = validateYouTubeUrl(values.video_link, "short");
                        if (shortError) {
                            error.video_link = shortError;
                        }
                    } else if (values.video_length === "long" && values.video_type === "link") {
                        // Validate for YouTube regular video
                        const longError = validateYouTubeUrl(values.video_link, "long");
                        if (longError) {
                            error.video_link = longError;
                        }
                    }
                    if (!values.video_type) {
                        error.video_type = "Please select a video type.";
                    }

                    if (values.video_type === "file") {
                        if (!values.video) {
                            error.video = "Please upload a video file.";
                        } else {
                            const isFile = values.video instanceof File || values.video instanceof Blob;
                            if (isFile) {
                                if (!allowedTypes.includes(values.video.type)) {
                                    error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                                }

                                const fileSizeMB = values.video.size / (1024 * 1024);
                                if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                                    error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                                }
                            }
                        }
                    } else if (values.video_type === "link") {
                        if (!values.video_link || !values.video_link.trim()) {
                            error.video_link = "Please enter a video link.";
                        } 
                        // else {
                        //     const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
                        //     if (!urlPattern.test(values.video_link)) {
                        //         error.video_link = "Please enter a valid video link.";
                        //     }
                        // }
                    }                                           
                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    globalLoader(true);
                    let formData = new FormData();
                    formData.append("o_id", params.id);
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    // formData.append("category", values.category);
                    formData.append("video_length", values.video_length);
                    formData.append("video_type", values.video_type);
                    if(values.video_type === "file" && values.video){
                        formData.append("video", values.video || "");
                    } else if(values.video_type === "link" && values.video_link){
                        formData.append("video_link", values.video_link || "");
                    }
                    if (values?.thumbnail_image) {
                        formData.append("thumbnail_image", values.thumbnail_image);
                    }
                        EditEducationalVideo(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                if (saveType !== "Save") {
                                    setTimeout(() => {
                                        resetForm({ values: "" });
                                        globalLoader(false);
                                        navigate(`/admin/center-management/center/educational-video/${center_id}/list/1`);
                                    }, 1000);
                                }
                                if (saveType === "Save") {
                                    setTimeout(() => {
                                        globalLoader(false);
                                    }, 1000);
                                }
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        {console.log("values===>", values)}
                        {console.log("errors===>", errors)}
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Edit Video")}</h6>
                                        </div>
                                        {showdefault && Object.keys(showdefault).length > 0 ? (
                                            <div className="row row-sm">

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="title" className="text-left d-flex">
                                                        {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="title"
                                                        id="title"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}
                                                        className="form-control"
                                                        placeholder={t("admin.faq.faq_title_placeholder")}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.title && touched.title && t(errors.title)}
                                                    </span>
                                                </div>

                                                {/* <div className="col-md-6 text-center form-group">
                                                    <label className="text-left d-flex">
                                                        {t("Category")}
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <select className="form-control form-select cp" name='category' value={values?.category} onChange={handleChange}>
                                                        <option value={""}>{t("Select")}</option>
                                                        {categories?.map((item, index) => { return (<option key={item._id} value={item.category}>{capitalizeFirstLetter(item.category)}</option>) })}
                                                    </select>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.category && touched.category && t(errors.category)}
                                                    </span>
                                                </div> */}

                                                <div className="col-lg-12 text-center form-group">
                                                    <label htmlFor="description" className="text-left d-flex">
                                                        {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <CustomCkeditor
                                                        fieldname={"description"}
                                                        setFieldValue={setFieldValue}
                                                        value={values.description}
                                                        setFieldTouched={setFieldTouched}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.description &&
                                                            touched.description &&
                                                            t(errors.description)}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="thumbnail_image" className="text-left d-flex">
                                                        Upload Thumbnail Image:
                                                        {" "}
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="thumbnail_image"
                                                        name="thumbnail_image"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                           setFieldValue(
                                                                "thumbnail_image",
                                                                event.target.files[0] || ""
                                                            );
                                                            event.target.files.length === 1
                                                                ? setPreviewImage(
                                                                    URL.createObjectURL(event.target.files[0])
                                                                )
                                                                : setPreviewImage("");
                                                        }}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                    {errors.thumbnail_image &&
                                                        touched.thumbnail_image &&
                                                        t(errors.thumbnail_image)}
                                                    </span>
                                                    {previewimage ? (
                                                        <ul className="question-image-preview questions-ul">
                                                            <li className="pr_img_box">
                                                                <img
                                                                    src={previewimage}
                                                                    style={{ height: "100px" }}
                                                                    alt={"profileImg"}
                                                                />
                                                            </li>
                                                        </ul>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="video_length" className="text-left d-flex">
                                                        Select Video Length:<span className="requirestar">*</span>
                                                    </label>
                                                    <select
                                                        name="video_length"
                                                        id="video_length"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const selectedType = e.target.value;
                                                            setFieldValue("video_length", selectedType);
                                                            if(selectedType === "short"){
                                                            setFieldValue("video_type", "link");
                                                            setFieldValue("video", "");
                                                        }
                                                        }}
                                                        value={values.video_length}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="short">Short Video</option>
                                                        <option value="long">Long Video</option>
                                                    </select>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.video_length && touched.video_length && t(errors.video_length)}
                                                    </span>
                                                </div>

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="video_type" className="text-left d-flex">
                                                        Select Video Type:<span className="requirestar">*</span>
                                                    </label>
                                                    <select
                                                        name="video_type"
                                                        id="video_type"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const selectedType = e.target.value;
                                                            setFieldValue("video_type", selectedType);
                                                            // Clear the other field when switching
                                                            if (selectedType === "file") {
                                                                setFieldValue("video_link", "");
                                                                setFieldValue("video", showdefault.video || "");
                                                            } else {
                                                                setFieldValue("video", "");
                                                                setFieldValue("video_link", showdefault.video_link || "");
                                                            }
                                                        }}
                                                        value={values.video_type}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="file">Upload Video Manually</option>
                                                        <option value="link"> YouTube Link</option>
                                                    </select>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.video_type && touched.video_type && t(errors.video_type)}
                                                    </span>
                                                </div>


                                                {values.video_type === "file" && (
                                                    <div className="col-lg-6 text-center form-group">
                                                        <label htmlFor="video" className="text-left d-flex">
                                                            {t("Upload Video")}:<span className="requirestar">*</span>
                                                            <Whisper
                                                                placement="top"
                                                                controlId="control-id-hover"
                                                                trigger="hover"
                                                                speaker={
                                                                    <Tooltip>Maximum video upload size 15MB</Tooltip>
                                                                }
                                                            >
                                                                <span className="field-more-info mt-1 ms-1 cp">?</span>
                                                            </Whisper>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            name="video"
                                                            id="video"
                                                            accept="video/*"
                                                            className="form-control"
                                                            onChange={(event) => {
                                                                setFieldValue("video", event.currentTarget.files[0]);
                                                            }}
                                                        />
                                                        <span className="text-danger d-flex text-left">
                                                            {errors.video && touched.video && t(errors.video)}
                                                        </span>

                                                        {showVideoData && (
                                                            <ul className="question-image-preview questions-ul">
                                                                <li className="pr_img_box">
                                                                    <video
                                                                        src={showVideoData}
                                                                        style={{ height: "100px" }}
                                                                        controls
                                                                    />
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div>
                                                )}


                                                {values.video_type === "link" && (
                                                    <div className="col-lg-6 text-center form-group">
                                                        <label htmlFor="video_link" className="text-left d-flex">
                                                            Upload Video Link:<span className="requirestar">*</span>
                                                        </label>
                                                        <input
                                                            name="video_link"
                                                            id="video_link"
                                                            type="text"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.video_link}
                                                            className="form-control"
                                                            placeholder="Enter video link"
                                                        />
                                                        <span className="text-danger d-flex text-left">
                                                            {errors.video_link && touched.video_link && t(errors.video_link)}
                                                        </span>
                                                    </div>
                                                )}


                                                <div className="">
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("Save");
                                                        }}
                                                        className="btn btn-info mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save")}
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("");
                                                        }}
                                                        className="btn btn-success mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save_exit")}
                                                    </button>
                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        type="button"
                                                        onClick={() => navigate(-1)}
                                                    >
                                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_cancel")}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <Loader />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            ) : (
                <Loader />
            )}

        </>
    );
};

export default EducationalVideoEdit;
